import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { Observable } from 'rxjs';
import { PromoRepository } from '../../../repositories/promo.repository';
import { PostValidateHaloNumberDto, PostValidateHaloNumberResp } from './post-validate-halo-number.type';

@Injectable({
    providedIn: 'root'
})

export class PostValidateHaloNumberUsecase implements UseCase<PostValidateHaloNumberDto, PostValidateHaloNumberResp> {
    private readonly promoRepository = inject(PromoRepository);

    execute(params: PostValidateHaloNumberDto): Observable<PostValidateHaloNumberResp> {
        return this.promoRepository.PostValidateHaloNumber(params);
    }
}